// extracted by mini-css-extract-plugin
export var equalColumn = "_dv-0";